import { Button, ButtonProps, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { event_registration_clicked } from '@/analytics';

import { AddToCartModal } from '@/components/TicketedEventRegistrationButton/components/EventRegistrationModal';
import { ExternalRegistrationModal } from '@/components/TicketedEventRegistrationButton/components/ExternalRegistrationModal';

interface BuyTicketsButtonProps extends ButtonProps {
  eventId: string;
  eventName: string;
  eventStartDate: string;
  eventEndDate: string;
  isConference: boolean;
  isExternalRegistrationUrlActive?: boolean;
  externalRegistrationUrl?: string | null;
  useLearningRegistrationCopy?: boolean;
}

export const BuyTicketsButton: React.FC<BuyTicketsButtonProps> = ({
  eventId,
  eventName,
  eventStartDate,
  eventEndDate,
  isConference,
  isExternalRegistrationUrlActive,
  externalRegistrationUrl,
  useLearningRegistrationCopy,
  ...props
}) => {
  const modalDisclosure = useDisclosure();

  const handleClick = () => {
    // Event user journey: member clicked Buy Tickets on a ticketed simple/conference event
    event_registration_clicked({
      entity: {
        id: eventId,
        type: isConference ? 'conference' : 'simple_event',
      },
      event: {
        name: eventName,
        type: isConference ? 'conference' : 'simple',
        startDate: eventStartDate,
      },
      ticket: {
        ticketOptions: [],
      },
    });

    modalDisclosure.onOpen();
  };

  return (
    <>
      <Button
        onClick={handleClick}
        colorScheme="blue"
        width={{ base: '100%', md: 'auto' }}
        {...props}
      >
        {useLearningRegistrationCopy ? 'Enroll' : 'Buy Tickets'}
      </Button>
      {isExternalRegistrationUrlActive && externalRegistrationUrl ? (
        <ExternalRegistrationModal
          isOpen={modalDisclosure.isOpen}
          onClose={modalDisclosure.onClose}
          externalRegistrationUrl={externalRegistrationUrl}
          useLearningRegistrationCopy={useLearningRegistrationCopy}
        />
      ) : (
        <AddToCartModal
          isOpen={modalDisclosure.isOpen}
          onClose={modalDisclosure.onClose}
          eventId={eventId}
          eventName={eventName}
          eventStartDate={eventStartDate}
          eventEndDate={eventEndDate}
          isConference={isConference}
        />
      )}
    </>
  );
};
